import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import {getAdBannerList, getMyOfferPriceList, getMyReceivedPriceList, getUserContact} from '@/api/miscellaneous';
import {onMounted} from 'vue';
import {useRoute, useRouter} from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'MyOfferPriceList',
  props: {
    tabindex: {
        type: Number,
        default: 0,
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props

const getListData = ref({
    page: 1,
    size: 10,
});

const active = ref(1);
const tabs = ref<any[]>([
    {name: 0, title: '我的报价', img: ''},
    {name: 1, title: '收到报价', img: ''},
]);

const adList = ref<any[]>([]);

const loading = ref(false);
const finished = ref(false);
const list = ref<any[]>([]);

const rloading = ref(false);
const rfinished = ref(false);
const rlist = ref<any[]>([]);
const rgetListData = ref({
    page: 1,
    size: 10,
});

const restrictShow = ref(false);
const restrictCode = ref('');
const tel = ref('');
const isShowTel = ref(false);


onMounted(() => {
    active.value = Number(route.query.tabindex == undefined || route.query.tabindex == 'NaN' ? 0 : route.query.tabindex);
    console.log(active.value, '-------------');
    if (active.value == 0) {
        getList();
    } else if (active.value == 1) {
        getreceivedList();
    }
});
//const router = useRouter();

const route = useRoute();

const onTabClick = (index: any) => {
    if (index == '0') {
        console.log(index, '--0--');
        // list.value = [];
        // finished.value = false;
        getListData.value.page = 1;
        getList();
    }
    if (index == '1') {
        console.log(index, '--1--');
        // rlist.value = [];
        // rfinished.value = false;
        rgetListData.value.page = 1;
        getreceivedList();
    }
};

const getList = () => {
    if (finished.value) return;
    loading.value = true;
    console.log(getListData.value);
    getMyOfferPriceList(getListData.value).then((res: any) => {
        loading.value = false;
        list.value = [...list.value, ...res.items];
        finished.value = res.count == 0 ? true : getListData.value.page * getListData.value.size > res.totalCount;
        getListData.value.page++;
    });
};

const getreceivedList = () => {
    if (rfinished.value) return;
    rloading.value = true;
    console.log(rgetListData.value);
    getMyReceivedPriceList(rgetListData.value).then((res: any) => {
        console.log(res, '--res');
        rloading.value = false;
        rlist.value = [...rlist.value, ...res.items];
        rfinished.value = res.count == 0 ? true : rgetListData.value.page * rgetListData.value.size > res.totalCount;
        rgetListData.value.page++;
    });
};

const getTel = (id: any) => {
    getUserContact({userid: id})
        .then(res => {
            tel.value = res;
            isShowTel.value = true;
        })
        .catch(e => {
            let {code} = e;
            if ([104, 107].includes(code)) {
                restrictCode.value = code;
                restrictShow.value = true;
            }
        });
};
const cancel = () => {
    tel.value = '';
    isShowTel.value = false;
};
const call = () => {
    window.location.href = 'tel:' + tel.value;
};
const getAdList = () => {
    getAdBannerList().then((res: any) => {
        adList.value = res;
    });
};
//getAdList();

const __returned__ = { getListData, active, tabs, adList, loading, finished, list, rloading, rfinished, rlist, rgetListData, restrictShow, restrictCode, tel, isShowTel, props, route, onTabClick, getList, getreceivedList, getTel, cancel, call, getAdList, ref, getAdBannerList, getMyOfferPriceList, getMyReceivedPriceList, getUserContact, onMounted, useRoute, useRouter }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})